import ConfirmOverlapModal from './confirm-overlap-modal.component'

export default ConfirmOverlapModal